<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2023-02-03 17:36:12
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2026-10-30 10:46:16
-->
<template>
  <div class="innovative innovative-accuimr" :class="{textj: language != 'en'}" ref="accuimr">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right flex justify_content_center">
        <div v-html="$t('product.accuimr.title')"></div>
        <div :class="language == 'en' ? 'p-l-15' : ''">
          <p v-for="(item, index) in $t('product.accuimr.des')" :key="index" v-html="item"></p>
        </div>
      </div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <div class="innovative-wrap-item flex p-b-150" :class="{align_items_center: language != 'en'}">
          <div class="flex_1">
            <img class="" :src="$t('product.accuimr.list[0].img')" alt="" srcset="">
          </div>
          <div class="flex_1 p-l-80 p-b-30">
            <div class="innovative-item-title" v-html="$t('product.accuimr.list[0].title')"></div>
            <div class="p-t-15 textj">
              <p :class="{'p-b-30': index < $t('product.accuimr.list[0].des').length - 1 && language != 'en'}" v-for="(item, index) in $t('product.accuimr.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-wrap-item p-t-0 posrel accuimr-characteristics">
        <img v-if="language != 'en'" class="wh100" :src="$t('product.accuimr.list[1].img')" alt="" srcset="">
        <div class="t-0 wh100 innovative-container p-t-50 p-b-50" :class="{posabs: language != 'en'}">
          <div class="innovative-characteristics">
            <el-row class="trans-list wh100 flex justify_content_between">
              <el-col :span="language == 'en' ? 24 : 16">
                <div class="innovative-item-title p-l-15" v-html="$t('product.accuimr.list[1].title')"></div>
                <div class="flex_1 flex flex_col justify_content_center p-l-5">
                  <div class="flex p-t-46">
                    <div class="flex_1 flex flex_col" :class="language == 'en' && index == 0 ? 'p-r-40' : ''" v-for="(item, index) in $t('product.accuimr.list[1].des')" :key="index">
                      <div class="innovative-wrap-item-title fz-22 p-b-20" v-html="item.title"></div>
                      <div>
                        <div class="innovative-characteristics-item" v-for="($item, $index) in item.list" :key="$index">
                          <p v-for="($p ,$i) in $item" :key="$i" v-html="$p"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col v-if="language != 'en'" :span="8" class="flex justify_content_center align_items_center">
                <img class="" :src="$t('product.accuimr.list[1].img1')" alt="" srcset="">
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="accuimr-advantages innovative-wrap-item">
        <div class="innovative-container">
          <div class="innovative-accuimr-m-h innovative-characteristics trans-list">
            <div class="innovative-item-title p-l-15" style="" v-html="$t('product.accuimr.list[2].title')"></div>
            <el-row class="flex align_items_center p-t-60 p-r-40 p-b-40">
              <el-col :span="language == 'en' ? 12 : 13" class="flex textc" style="padding-right: 5%;">
                <div class="flex_1" v-for="(item, index) in $t('product.accuimr.list[2].list')" :key="index">
                  <div>
                    <span class="num" v-html="item.num"></span>
                    <span class="" v-html="item.unit"></span>
                    <span class="posrel">
                      <span class="color_active posabs l-10" v-html="item.sign"></span>
                    </span>
                  </div>
                  <div class="fontw p-10" v-html="item.title"></div>
                </div>
              </el-col>
              <el-col :span="language == 'en' ? 12 : 11" class="textj" :style="language == 'en' ? '' : 'padding-left: 5%;'" v-html="$t('product.accuimr.list[2].des')"></el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div v-if="language == 'en'" class="p-t-30">
        <div class="innovative-container">
          <div class="innovative-item-title p-l-15 widauto ilblk p-r-100" v-html="$t('product.accuimr.moreInformation.title')"></div>
          <div class="accuimr-moreProduct flex align_items_center justify_content_center">
            <div v-html="$t('product.accuimr.moreInformation.des')"></div>
            <div class="p-l-20 p-r-20">
              <img class="wid100" :src="$t('product.accuimr.moreInformation.img')" alt="" srcset="">
            </div>
            <el-button class="moreProduct-btn" @click="openMoreProduct">{{ $t('product.accuimr.moreInformation.btn') }}</el-button>
          </div>
        </div>
      </div>
      <div class="innovative-container">
        <div class="innovative-wrap-item p-t-50 article">
          <div class="innovative-item-title p-l-15" v-html="$t('product.accuimr.article.title')"></div>
          <div class="p-t-15">
            <p class="p-t-15" v-for="(item, index) in $t('product.accuimr.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      custom-class="accuimr-dialog"
      width="890px">
      <div class="accuimr-dialog-content flex">
        <div class="">
          <img :src="$t('product.accuimr.moreInformation.dialog.img')">
        </div>
        <div class="flex_1 p-l-40 p-r-40 p-t-30">
          <div class="dialog-more-product-title p-b-10">{{$t('product.accuimr.moreInformation.dialog.title')}}</div>
          <el-form ref="moreProductForm" :model="formData" :rules="rules" label-position="top" class="accuimr-dialog-form">
            <el-form-item :label="$t('product.accuimr.moreInformation.dialog.form.lastName.label')" prop="lastName">
              <el-input v-model="formData.lastName" :placeholder="$t('product.accuimr.moreInformation.dialog.form.lastName.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('product.accuimr.moreInformation.dialog.form.firstName.label')" prop="firstName">
              <el-input v-model="formData.firstName" :placeholder="$t('product.accuimr.moreInformation.dialog.form.firstName.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('product.accuimr.moreInformation.dialog.form.email.label')" prop="email">
              <el-input v-model="formData.email" :placeholder="$t('product.accuimr.moreInformation.dialog.form.email.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('product.accuimr.moreInformation.dialog.form.institutionName.label')" prop="institutionName">
              <el-input v-model="formData.institutionName" :placeholder="$t('product.accuimr.moreInformation.dialog.form.institutionName.placeholder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('product.accuimr.moreInformation.dialog.form.profession.label')" prop="profession">
              <el-select v-model="formData.profession" :placeholder="$t('product.accuimr.moreInformation.dialog.form.profession.placeholder')" class="wid100">
                <el-option :label="item.label" :value="item.value" v-for="item in profession" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('product.accuimr.moreInformation.dialog.form.product.label')">
              <el-input v-model="formData.product" :disabled="true" :placeholder="$t('product.accuimr.moreInformation.dialog.form.product.placeholder')"></el-input>
            </el-form-item>
          </el-form>
          <div class="textc p-t-5 p-b-10">{{ $t('product.accuimr.moreInformation.dialog.privacyPolicy[0]') }} <span @click="privacyStatus = true" class="cursor_pointer color_active">{{ $t('product.accuimr.moreInformation.dialog.privacyPolicy[1]') }}</span></div>
          <el-button class="accuimr-dialog-btn wid100" @click="handleSubmit('moreProductForm')">{{ $t('product.accuimr.moreInformation.dialog.btn.title') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 隐私政策 -->
    <el-dialog
      title=""
      :visible.sync="privacyStatus"
      custom-class="license-dialog"
      width="960px">
      <div class="license-dialog-content">
        <div class="p-b-20" v-for="item, index in $t('license.policy.list')" :key="index">
          <p v-for="$item, $index in item" :key="$index" v-html="$item"></p>
        </div>
      </div>
      <div class="license-dialog-time">{{ $t('license.policy.date') }}</div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      dialogVisible: false,
      formData: {
        lastName: '', // 名
        firstName: '', // 姓
        institutionName: '', // 机构名称
        profession: '', // 职业
        email: '', // 邮箱
        product: 'AccuIMR CE'
      },
      rules: {
        lastName: [
          { required: true, message: this.$t('product.accuimr.moreInformation.dialog.form.lastName.required')[0], trigger: 'blur' }
        ],
        firstName: [
          { required: true, message: this.$t('product.accuimr.moreInformation.dialog.form.firstName.required')[0], trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('product.accuimr.moreInformation.dialog.form.email.required')[0], trigger: 'blur' },
          { required: true, message: this.$t('product.accuimr.moreInformation.dialog.form.email.required')[1], pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, trigger: 'blur' }
        ],
        institutionName: [
          { required: true, message: this.$t('product.accuimr.moreInformation.dialog.form.institutionName.required')[0], trigger: 'blur' }
        ],
        profession: [
          { required: true, message: this.$t('product.accuimr.moreInformation.dialog.form.profession.required')[0], trigger: 'change' }
        ],
        product: [
          { required: true, message: this.$t('product.accuimr.moreInformation.dialog.form.product.required')[0], trigger: 'blur' }
        ]
      },
      profession: [
        { label: this.$t('license.formData.profession.physician.name'), value: this.$t('license.formData.profession.physician.value') },
        { label: this.$t('license.formData.profession.technician.name'), value: this.$t('license.formData.profession.technician.value') },
        { label: this.$t('license.formData.profession.scientificResearch.name'), value: this.$t('license.formData.profession.scientificResearch.value') },
        { label: this.$t('license.formData.profession.other.name'), value: this.$t('license.formData.profession.other.value') }
      ],
      privacyStatus: false // 隐私政策
    }
  },
  computed: {
    ...mapGetters(['language', 'clientHeight'])
  },
  methods: {
    // 打开dialog
    openMoreProduct () {
      this.formData = {
        lastName: '',
        firstName: '',
        institutionName: '',
        profession: '',
        email: '',
        product: 'AccuIMR CE'
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.moreProductForm.resetFields()
      })
    },
    // 提交数据
    handleSubmit (formName) {
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          const parms = {
            lastName: this.formData.lastName,
            firstName: this.formData.firstName,
            institutionName: this.formData.institutionName,
            profession: this.formData.profession,
            email: this.formData.email,
            product: this.formData.product,
            type: 'en'
          }
          console.log(parms)
          this.$store.dispatch('app/submitIMR', parms).then((res) => {
            console.log(res)
            this.$refs[formName].resetFields()
            this.$message({
              dangerouslyUseHTMLString: true,
              duration: 5000,
              type: 'success',
              customClass: 'accuimr-dialog-message justify_content_center',
              message: this.$t('product.accuimr.moreInformation.dialog.btn.success')
            })
          }).catch((err) => {
            console.log(err)
            this.$refs[formName].resetFields()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
.pc.en .innovative-accuimr {
  .accuimr-dialog {
    border-radius: 20PX;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14PX;
      color: #333333;
    }
    .el-form-item {
      margin-bottom: 6PX;
    }
    .el-form-item__label {
      padding: 0;
      padding-top: 10PX;
      line-height: 24PX;
      color: #000000;
      font-size: 16PX;
      position: relative;
    }
    .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
      color: #FF0909;
      font-size: 16PX;
      position: absolute;
      right: -16PX;
      top: 12PX;
    }
    .el-input__inner {
      border-radius: 0;
      border-top: none;
      border-left: none;
      border-right: none;
      color: #333333;
      padding: 0;
    }
    .el-input.is-disabled .el-input__inner {
      background-color: transparent;
    }
  }
  .license-dialog {
    height: 75vh;
    .el-dialog__body {
      height: calc(100% - 40PX);
      overflow: auto;
    }
    .license-dialog-content {
      // height: calc(100% - 40PX);
      color: #333333;
      word-break: initial;
    }
    .license-dialog-time {
      color: #8B8B8B;
      padding-top: 14PX;
    }
  }
}
.accuimr-dialog-message {
  background-color: rgba(0, 0, 0, 0.8);
  border-width: 0;
  min-width: 280PX;
  top: 50% !important;
  transform: translateX(-50%, -50%);
  .el-message__content {
    color: #ffffff;
  }
  .el-icon-success {
    color: #ffffff;
  }
}
</style>

<style lang="less" scoped>
.pc .innovative-accuimr {
  padding-bottom: 50PX;
  .innovative-characteristics {
    padding: 50PX 65PX;
  }
  .accuimr-advantages {
    background: #F8FBFF;
    padding: 50PX 0;
  }
  .innovative-accuimr-m-h {
    background: #FFFFFF;
    box-shadow: 0PX 4PX 12PX 4PX rgba(81, 170, 255, 0.1);
    padding: 55PX 28PX;
    font-size: 16PX;
    .color_active {
      color: #00A4EC;
    }
    .num {
      .color_active;
      font-size: 32PX;
      font-weight: 600;
    }
  }
}
.pc.en .innovative-accuimr {
  .accuimr-characteristics {
    background-image: url('~@/assets/images/innovate/AccuIMR/2.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
  .accuimr-moreProduct {
    background: rgba(157, 220, 255, 0.1);
    border-radius: 8PX;
    padding: 30PX 20PX;
    font-size: 16PX;
    .moreProduct-btn {
      background: #179BE3;
      border-radius: 10PX;
      height: 50PX;
      color: #ffffff;
    }
  }
  .dialog-more-product-title {
    color: #333333;
    font-size: 20PX;
    text-align: center;
  }
  .accuimr-dialog-btn {
    background: #179BE3;
    border-radius: 10PX;
    height: 50PX;
    color: #ffffff;
    font-size: 14PX;
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1560PX) {
  .pc.zh .innovative-accuimr {
    .accuimr-characteristics {
      height: 500PX;
    }
  }
}
@media screen and (max-width: 1250PX) {
  .pc.zh .innovative-accuimr {
    .accuimr-characteristics {
      height: 600PX;
    }
  }
}
@media screen and (max-width: 1010PX) {
  .pc.zh .innovative-accuimr {
    .accuimr-characteristics {
      height: 680PX;
    }
  }
}
</style>
